module.exports = __webpack_public_path__ + "media/mypage/images/ok-c32560a3f40260857f5c30912a8590cd.png";